
































































import {Vue, Component} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import { getToday } from '@/utils/dateUtils';
import { createExcel } from '@/components/common/grid/ExcelCreateUtil';
import { State } from 'vuex-class';
import { Mall } from 'ncp-api-supporter';
import { getDateDiff } from '@/pro/utils/dateFormat';

const MAX_PAGE_SIZE = 999999999;
const THREE_MONTH = 92;

@Component({
  components: {
    CompSelectBox,
    PeriodDateCalendar,
    CompRadioButton
  }
})
export default class SettlementExcelPopup extends Vue {
  @State('malls', {namespace: 'mall'}) private malls!: Mall[];

  private mallNo = 0;
  private startDate = this.getMonthBeginning;
  private endDate = getToday();
  private includesDeliveryAmt = true;

  private readonly periodOption = {
    havePeriodBtn: false,
  };

  private readonly shippingCostRadioOptions = {
    name: 'shippingCostRadioOptions',
    data: [
      {
        id: 'include',
        value: true,
        dispaly: 'MALL_SETTLEMENT_DATA_POPUP_INCLUDE',
      },
      {
        id: 'not_include',
        value: false,
        dispaly: 'MALL_SETTLEMENT_DATA_POPUP_NOT_INCLUDE',
      },
    ],
  };

  private get mallList() {
    const list = [{
      value: 0,
      name: this.$t('COMMON_ERR_MALLNO_NULL'),
    }]

    this.malls.forEach(({ mallNo, mallName, used }) => {
      used && list.push({ value: mallNo, name: mallName });
    });

    return list
  };

  private get getMonthBeginning() {
    const today = getToday().split('-');
    today[today.length -1] = '01';

    return today.join('-');
  }

  private excelDownload() {
    if (!this.mallNo) {
      alert(this.$t('COMMON_ERR_MALLNO_NULL'));

      return;
    }

    const diffStartAndEnd = getDateDiff(this.startDate, this.endDate, 'days')

    if (diffStartAndEnd > THREE_MONTH || diffStartAndEnd < -THREE_MONTH) {
      alert(this.$t('MALL_SETTLEMENT_DATA_POPUP_DATE_MAX_RANGE'));

      return;
    }

    createExcel(
      this,
      true,
      {
        mallNo: this.mallNo,
        endYmd: this.endDate,
        startYmd: this.startDate,
        page: 1,
        size: MAX_PAGE_SIZE,
        includesDeliveryAmt: this.includesDeliveryAmt
      },
      'PREMIUM_MALL_SETTLEMENT',
      `${this.startDate.replaceAll('-', '')}_${this.endDate.replaceAll('-', '')}`
    )
  };

  private closePopup() {
    window.close();
  }
}
